import { verifyEmailWithCode } from '../api/verification';
import { GA_EVENTBRITE } from '../constants/analytics';
import { IAllContextsProps } from '../constants/interfaces';
import { VERIFICATION_STATUSES } from '../constants/status';
import {
    trackVerificationFailed,
    trackVerificationSuccessful,
} from '../tracking/verification';

export const verifyEmailWithCodeAction = ({
    email,
    target,
    verificationCode,
    contexts,
    onVerificationSuccessful,
}: {
    email: string;
    target: string;
    verificationCode: string;
    contexts: IAllContextsProps;
    onVerificationSuccessful: (verificationCode: string) => void;
}) => {
    const analytics = contexts.configContext?.analytics;

    contexts.frontendContext?.methods.setIsModalLoading(true);

    contexts.userContext?.methods.setEmailVerificationStatus(
        VERIFICATION_STATUSES.empty,
    );

    return verifyEmailWithCode({
        email,
        target,
        verificationCode,
    })
        .then(() => {
            trackVerificationSuccessful({
                socialProvider: GA_EVENTBRITE,
                analytics,
            });

            contexts.userContext?.methods.setEmailVerificationStatus(
                VERIFICATION_STATUSES.success,
            );
            contexts.userContext?.methods?.setVerificationCode(
                verificationCode,
            );

            onVerificationSuccessful(verificationCode);
        })
        .catch((error: any) => {
            const errorCode =
                error?.parsedError?.error ??
                error?.response?.statusText ??
                'Error not defined';

            trackVerificationFailed({
                errorMessage: errorCode,
                analytics,
            });

            switch (errorCode) {
                case 'INVALID_VERIFICATION_CODE':
                    contexts.userContext?.methods.setEmailVerificationStatus(
                        VERIFICATION_STATUSES.failed,
                    );
                    break;
                case 'MAX_ATTEMPTS_REACHED':
                    contexts.userContext?.methods.setEmailVerificationStatus(
                        VERIFICATION_STATUSES.maxTries,
                    );
                    break;
            }
        })
        .finally(() => {
            contexts.frontendContext?.methods.setIsModalLoading(false);
        });
};
